import { toJS } from "mobx";
import moment from "moment";

import Utils from "./utils";
import AuthStore from "modules/login/store/AuthStore";
import FamilyMemberTypeEnum from 'modules/family-details-form/FamilymemberTypeEnum'

const initialDefaults = (formRef, data) => {
  let productData = data.data;
  let biResponse = productData.parsedResponse;
  let biRequest = productData.bi_request;

  let frequency = biRequest.INPUT_MODE.toString();
  let annuityOption = biRequest.AnnuityOption;
  let sourceofPurchasePrice = biRequest.SourceofPurchasePrice;
  let frequencyofAnnuity = biRequest.FrequencyofAnnuity;
  let premium = biRequest.PR_ANNPREM;
  let areYouNominee = biRequest.AreyoutheNominee;

  let secondary_annuitant_name = biRequest.NameoftheSecondaryAnnuitant;
  let secondary_annuitant_date_of_birth = biRequest.OSNAnnuitantDateOfBirth;
  let secondary_annuitant_gender = biRequest.GenderofSecondaryAnnuitant;

  let journeyData = toJS(AuthStore.journeyData);
  let familyMemberType = data.data.family_member_type


  let genderList = {"Male":'13',"Female" :'14'}

  switch (familyMemberType) {
        
    case 'SELF':
        let spouseDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SPOUSE)

            if(spouseDetail) {
                 secondary_annuitant_name = spouseDetail.middle_name ? `${spouseDetail.first_name} ${spouseDetail.middle_name} ${spouseDetail.last_name}` : `${spouseDetail.first_name} ${spouseDetail.last_name}`
    
                 secondary_annuitant_date_of_birth = spouseDetail.dob 
    
                 secondary_annuitant_gender = genderList[spouseDetail.gender]
            }

        break;

    case 'SPOUSE':
    let selfDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SELF)

        if(selfDetail){
            secondary_annuitant_name = selfDetail.middle_name ? `${selfDetail.first_name} ${selfDetail.middle_name} ${selfDetail.last_name}` : `${selfDetail.first_name} ${selfDetail.last_name}`

            secondary_annuitant_date_of_birth = selfDetail.dob 

            secondary_annuitant_gender = genderList[selfDetail.gender]
        }    

    break;

    case 'GRAND_FATHER':
        let grandMotherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)

            if(grandMotherDetail){
                secondary_annuitant_name = grandMotherDetail.middle_name ? `${grandMotherDetail.first_name} ${grandMotherDetail.middle_name} ${grandMotherDetail.last_name}` : `${grandMotherDetail.first_name} ${grandMotherDetail.last_name}`

                secondary_annuitant_date_of_birth = grandMotherDetail.dob 
    
                secondary_annuitant_gender = genderList[grandMotherDetail.gender]
            }

        break;

    case 'GRAND_MOTHER':
        let grandFatherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)

            if(grandFatherDetail){
                secondary_annuitant_name = grandFatherDetail.middle_name ? `${grandFatherDetail.first_name} ${grandFatherDetail.middle_name} ${grandFatherDetail.last_name}` : `${grandFatherDetail.first_name} ${grandFatherDetail.last_name}`

                secondary_annuitant_date_of_birth = grandFatherDetail.dob 
    
                secondary_annuitant_gender = genderList[grandFatherDetail.gender]
            }

        break;

        
        default:
          break;
        }
  
  // ! secondary-annuitant-name      
  formRef.$('name-of-the-secondary-annuitant').set('value', secondary_annuitant_name)

  // ! secondary-annuitant-date-of-birth
formRef.$('dob-of-secondary-annuitant').set('value', secondary_annuitant_date_of_birth)

  // ! secondary-annuitant-gender
switch (secondary_annuitant_gender) {
  case '13':
      formRef.$('gender-secondary-annuitant').set('value', {label:"Male",id:'5'})
      break;
  case '14':
      formRef.$('gender-secondary-annuitant').set('value', {label:"Female",id:'6'})
      break;    
  default:
      break;
 }


  formRef.$("premium").value = premium;

  formRef.$("premium-term").value = {
    id: biRequest.PR_PPT,
    label: biRequest.PR_PPT,
  };

  switch (areYouNominee) {
    case "18":
      formRef.$("are-you-nominee").set("value", {
        id: "18",
        label: "Yes",
      });
      break;

    case "19":
      formRef.$("are-you-nominee").set("value", {
        id: "19",
        label: "No",
      });
      break;

    default:
      break;
  }

  switch (frequency) {
    case "5":
      formRef.$("payment-frequency").set("value", {
        id: "5",
        label: "Single",
      });
      break;

    default:
      break;
  }

  switch (annuityOption) {
    case "1":
      formRef.$("annuity-option").set("value", {
        id: "1",
        label: "Life Annuity with Return of Purchase Price",
      });
      break;
    case "2":
      formRef.$("annuity-option").set("value", {
        id: "2",
        label: "Life Annuity",
      });
      break;
    case "3":
      formRef.$("annuity-option").set("value", {
        id: "3",
        label: "Life Annuity Certain for 5 years",
      });
      break;
    case "4":
      formRef.$("annuity-option").set("value", {
        id: "4",
        label: "Life Annuity Certain for 10 years",
      });
      break;
    case "5":
      formRef.$("annuity-option").set("value", {
        id: "5",
        label: "Life Annuity Certain for 15 years",
      });
      break;
    case "6":
      formRef.$("annuity-option").set("value", {
        id: "6",
        label: "Life Annuity Certain for 20 years",
      });
      break;
    case "7":
      formRef.$("annuity-option").set("value", {
        id: "7",
        label: "Life Annuity Increasing at a simple rate of 3% per annum",
      });
      break;
    case "8":
      formRef.$("annuity-option").set("value", {
        id: "8",
        label: "Life Annuity Increasing at a simple rate of 5% per annum",
      });
      break;
    case "9":
      formRef.$("annuity-option").set("value", {
        id: "9",
        label: "Joint Life, Last Survivor",
      });
      break;
    case "10":
      formRef.$("annuity-option").set("value", {
        id: "10",
        label: "Joint Life, Last Survivor with 50% annuity",
      });
      break;
    case "11":
      formRef.$("annuity-option").set("value", {
        id: "11",
        label:
          "Joint Life, Last Survivor with Return of Purcahse Price on Last Death",
      });
      break;

    default:
      break;
  }

  switch (sourceofPurchasePrice) {
    case "15":
      formRef.$("source-of-purchase-price").set("value", {
        id: "15",
        label: "Proceeds of pension policy of ETLI Co Ltd",
      });
      break;
    case "16":
      formRef.$("source-of-purchase-price").set("value", {
        id: "16",
        label: "Proceeds of pension policy of other Insurer",
      });
      break;
    case "17":
      formRef.$("source-of-purchase-price").set("value", {
        id: "17",
        label: "Open Market",
      });
      break;

    default:
      break;
  }

  switch (frequencyofAnnuity) {
    case "20":
      formRef.$("frequency-of-annuity").set("value", {
        id: "20",
        label: "Yearly",
      });
      break;
    case "21":
      formRef.$("frequency-of-annuity").set("value", {
        id: "21",
        label: "Half-Yearly",
      });
      break;
    case "22":
      formRef.$("frequency-of-annuity").set("value", {
        id: "22",
        label: "Quarterly",
      });
      break;
    case "23":
      formRef.$("frequency-of-annuity").set("value", {
        id: "23",
        label: "Monthly",
      });
      break;

    default:
      break;
  }
  
};

export default initialDefaults;
